module.exports = __webpack_public_path__ + "static/media/serious.abb2b00e.svg";